/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.PublicProductRpc
 */

export let ComHubspotBuyingModelsRpcEnums;
(function (_ComHubspotBuyingModelsRpcEnums) {})(ComHubspotBuyingModelsRpcEnums || (ComHubspotBuyingModelsRpcEnums = {}));
export let ComHubspotBuyingModelsRpcProductAbstractPublicProductRpcError;
(function (_ComHubspotBuyingModelsRpcProductAbstractPublicProductRpcError) {})(ComHubspotBuyingModelsRpcProductAbstractPublicProductRpcError || (ComHubspotBuyingModelsRpcProductAbstractPublicProductRpcError = {}));
/**
 *  {@code term} is the FE-facing pricing-page bucket (MONTHLY/ANNUAL); {@code commitmentTerm} and
 *  {@code paymentTerm} are the actual billing terms behind it (e.g. an ANNUAL commitment paid
 *  MONTHLY), which the term toggle and checkout need.
 */
/**
 *  The user's raw Create-a-Bundle selection plus display context. A CAB-owned type (not
 *  PurchaseRequestV2) so this public, no-auth input stays decoupled from the checkout/purchase type.
 */
/**
 *  Paint-ready cart state. {@code purchaseMotions}, {@code checkout}, {@code eligibleAddOnApiNames},
 *  and {@code priceBreakdown} are filled in by later PRs.
 */
/**
 * Checkout handoff: the resolved PurchaseRequestV2 the FE forwards to the CTA; populated in a later PR.
 */
/**
 * A requested quantity pack: parent product + quantity name + additional packs to buy.
 */
/**
 * Pre-aggregated totals for both terms; discounted equals list when the cart has no shared discount.
 */
/**
 * {@code showToggle} is false when the term can't be changed (ent-only, or no common terms).
 */
/**
 * A node in the resolved-cart tree; top-level products carry their quantity packs as children.
 */
/**
 * A flat row for the price-breakdown modal; populated in a later PR.
 */
/**
 * Stepper metadata for a quantity-pack or core-seat line; populated in a later PR.
 */
export let ComHubspotBuyingModelsRpcProductPricingpagedetailsAbstractPricingPageDetailsError;
(function (_ComHubspotBuyingModelsRpcProductPricingpagedetailsAbstractPricingPageDetailsError) {})(ComHubspotBuyingModelsRpcProductPricingpagedetailsAbstractPricingPageDetailsError || (ComHubspotBuyingModelsRpcProductPricingpagedetailsAbstractPricingPageDetailsError = {}));
/**
 *  Request model for purchasing parent products.
 *  <p>
 *    Exactly one of incrementalQuantity or skuQuantity must be set.
 *    Prefer using incrementalQuantity for clarity.
 *  </p>
 *  <p>
 *    Use incrementalQuantity to indicate net new copies of the SKU to add in the purchase.
 *    Use skuQuantity to indicate total quantity of the SKU that should be owned post-purchase.
 *  </p>
 */
/**
 *  Request model for purchasing quantity packs.
 *  <p>
 *    Exactly one of incrementalQuantity or skuQuantity must be set.
 *    Prefer using incrementalQuantity for clarity.
 *  </p>
 *  <p>
 *    Use incrementalQuantity to indicate net new copies of the SKU to add in the purchase.
 *    Use skuQuantity to indicate total quantity of the SKU that should be owned post-purchase.
 *  </p>
 */
export let ComHubspotPurchaseOptionsModelsRpc;
(function (_ComHubspotPurchaseOptionsModelsRpc) {})(ComHubspotPurchaseOptionsModelsRpc || (ComHubspotPurchaseOptionsModelsRpc = {}));
export const getProductsRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getProducts',
  auth: 'external',
  fingerprint: 'y60Ckx8OiE-wHbmlAUeySJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
  routingLocality: 'GLOBAL'
};
export const getPublicProductsV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicProductsV2',
  auth: 'external',
  fingerprint: 'y60Ckx8OiE-wHbmlAUeySPIChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
  routingLocality: 'GLOBAL'
};
export const getBundleRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getBundle',
  auth: 'external',
  fingerprint: 'MecQcEhAC43eGrqy_S_6wJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
  routingLocality: 'GLOBAL'
};
export const getAddOnsRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getAddOns',
  auth: 'external',
  fingerprint: 'W1sIsXps8S0cTK6AliWoS5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
  routingLocality: 'GLOBAL'
};
export const getPublicAddOnsV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicAddOnsV2',
  auth: 'external',
  fingerprint: 'W1sIsXps8S0cTK6AliWoS_IChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
  routingLocality: 'GLOBAL'
};
export const getGrowthPurchaseOptionsRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getGrowthPurchaseOptions',
  auth: 'external',
  fingerprint: '-W1SoCcW1jMe2aHLPayFr5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
  routingLocality: 'GLOBAL'
};
export const getPublicGrowthPurchaseOptionsV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicGrowthPurchaseOptionsV2',
  auth: 'external',
  fingerprint: 'ERFOJ4WkWq8e2aHLPayFr_IChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
  routingLocality: 'GLOBAL'
};
export const getGrowthPurchaseOptionsUsingCombinedTermsRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getGrowthPurchaseOptionsUsingCombinedTerms',
  auth: 'external',
  fingerprint: '5fhFB1_q8zfOvw0uJxxD4pwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
  routingLocality: 'GLOBAL'
};
export const getPublicCurrencyResponseRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicCurrencyResponse',
  auth: 'external',
  fingerprint: 'LcY_1HcXExpCxNsiV75fV5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
  routingLocality: 'GLOBAL'
};
export const getPublicCurrencyV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicCurrencyV2',
  auth: 'external',
  fingerprint: '0A0s8MXPGwNCxNsiV75fV_IChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
  routingLocality: 'GLOBAL'
};
export const getPublicPhoneNumberRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicPhoneNumber',
  auth: 'external',
  fingerprint: '3XnPSFhmU52JvnxBO5sLIUIvbGFwJ20M',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
  routingLocality: 'GLOBAL'
};
export const getPublicPhoneNumberV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicPhoneNumberV2',
  auth: 'external',
  fingerprint: '2Zi9eBzh3FKJvnxBO5sLIfIChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
  routingLocality: 'GLOBAL'
};
export const getPublicFeatureFlagsRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicFeatureFlags',
  auth: 'external',
  fingerprint: 'xqbfhmS3i9U9llyZwSnPm0IvbGFwJ20M',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
  routingLocality: 'GLOBAL'
};
export const getPublicFeatureFlagsV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicFeatureFlagsV2',
  auth: 'external',
  fingerprint: 'PX4qAyKA8wE9llyZwSnPm_IChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
  routingLocality: 'GLOBAL'
};
export const getPublicPricingPageDetailsRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicPricingPageDetails',
  auth: 'external',
  fingerprint: 'yMREVRptkqIpmSkMPLJIb0IvbGFwJ20M',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
  routingLocality: 'GLOBAL'
};
export const getPublicProductUseCasesV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicProductUseCasesV2',
  auth: 'external',
  fingerprint: 'NKmN02BwKb5uX-ADA6q3QfIChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
  routingLocality: 'GLOBAL'
};
export const getPublicProductUseCasesV3Rpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicProductUseCasesV3',
  auth: 'external',
  fingerprint: 'NKmN02BwKb5uX-ADA6q3QfIChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
  routingLocality: 'GLOBAL'
};
export const getPublicProductPlanRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicProductPlan',
  auth: 'external',
  fingerprint: 'YBqQrLcyZvVdbWZLJi1_MvIChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
  routingLocality: 'GLOBAL'
};
export const getPublicProductPlanV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicProductPlanV2',
  auth: 'external',
  fingerprint: 'Ds4a0zASBrEEGszoOnx7iPIChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
  routingLocality: 'GLOBAL'
};
export const getPublicProductBadgesRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicProductBadges',
  auth: 'external',
  fingerprint: '08RwPDYX0FPpwqK0OaEJuvIChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
  routingLocality: 'GLOBAL'
};
export const getPublicProductTierOptionsRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicProductTierOptions',
  auth: 'external',
  fingerprint: 'og_oeQZsHAondRXvTBkKOfIChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
  routingLocality: 'GLOBAL'
};
export const getPublicProductTierOptionsV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicProductTierOptionsV2',
  auth: 'external',
  fingerprint: 'lTEKcS_yx-erAUUq9NzQ4vIChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
  routingLocality: 'GLOBAL'
};
export const getPublicProductConfigurationOptionsRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicProductConfigurationOptions',
  auth: 'external',
  fingerprint: 'EcrdcPCOV7vG7LSook181PIChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
  routingLocality: 'GLOBAL'
};
export const getPublicCabProductsRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicCabProducts',
  auth: 'external',
  fingerprint: 'oX0aVL87gr2wHbmlAUeySPIChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
  routingLocality: 'GLOBAL'
};
export const calculateCartRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'calculateCart',
  auth: 'external',
  fingerprint: 'mUbZ-39j_X9uxxwdFkzhvvIChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
  routingLocality: 'GLOBAL'
};
export const getPublicProductGroupsRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicProductGroups',
  auth: 'external',
  fingerprint: 'XRFknZmNVYoNLrM6LINdRvIChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
  routingLocality: 'GLOBAL'
};
export const getCreditActionsRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getCreditActions',
  auth: 'external',
  fingerprint: 'MeGKpeYb3YsnrJEZEcW5i_IChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
  routingLocality: 'GLOBAL'
};
export const getCreditRatesRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getCreditRates',
  auth: 'external',
  fingerprint: 'sZ6v_jdplekUiCb2BjOue_IChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
  routingLocality: 'GLOBAL'
};
export const getPublicRecommendationsRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getPublicRecommendations',
  auth: 'external',
  fingerprint: '_tEf9pRilyHRuvRyfI1O_fIChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
  routingLocality: 'GLOBAL'
};
export const processPublicRecommendationRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'processPublicRecommendation',
  auth: 'external',
  fingerprint: 'wPqTOF483omozh6W4mylWfIChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
  routingLocality: 'GLOBAL'
};
export const processManualPublicRecommendationRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'processManualPublicRecommendation',
  auth: 'external',
  fingerprint: 'ZaxP42-MZtXxSt0qecLwjvIChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
  routingLocality: 'GLOBAL'
};
export const setPublicRecommendationFeedbackRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'setPublicRecommendationFeedback',
  auth: 'external',
  fingerprint: 'VIRQDNxyR-2Y_ZPUEqSSFPIChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
  routingLocality: 'GLOBAL'
};
export const getFeatureTableRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicProductRpc',
  rpcName: 'getFeatureTable',
  auth: 'external',
  fingerprint: 'cFtG9EV7uP4i40qdqQ_lR_IChmB-GqzD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
  routingLocality: 'GLOBAL'
};